import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

export const addMassYPadding = (items: any[], size?: string) =>
  items.map((i) => ({
    $el: 'div',
    attrs: {
      class: `my-${size || 2}`,
    },
    children: [i],
  }))

export const getUniqueStringValues = (items: string[]) => {
  return Array.from(new Set(items))
}

export const handlePossibleArrayValue = <T>(value: T) =>
  Array.isArray(value) ? value : [value]

export const copytext = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)
    notify('Copied')
  } catch (e) {
    alert('Cannot copy')
  }
}

export const isKare = (): boolean => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost') {
      return window.location.href.includes('kare')
    }
    return window.location.hostname.includes('kare')
  }
  return !!process.env?.NUXT_PUBLIC_API_HOST?.includes('kare')
}

export const formatDate = (d, timeIncluded?: boolean, utc?: boolean) => {
  if (utc) {
    return d
      ? dayjs(d)
          .utc(true)
          .tz(dayjs.tz.guess())
          .format(`YYYY-MM-DD${timeIncluded === true ? ' HH:mm:ss' : ''}`)
      : null
  }

  return d
    ? dayjs(d).format(`YYYY-MM-DD${timeIncluded === true ? ' HH:mm:ss' : ''}`)
    : null
}

export const areEqual = (a, b) => {
  if (a === undefined && b === undefined) {
    return true
  }
  if (a === null && b === null) {
    return true
  }
  if (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === 0 &&
    b.length === 0
  ) {
    return true
  }

  return JSON.stringify(a) === JSON.stringify(b)
}

export const formatNumber = (n: number | string) => {
  let strValue = typeof n === 'string' ? n : n.toString()
  let [integerPart, decimalPart] = strValue.split('.')
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart
}

export const isProduction = () => process.env?.NODE_ENV === 'production'
export const isStaging = () => process.env?.NODE_ENV === 'staging'
export const jsonClone = (o) => JSON.parse(JSON.stringify(o))
